// extracted by mini-css-extract-plugin
export default {"dark":"PasswordRequirements_dark__OUtU8","passwordRequirements":"PasswordRequirements_passwordRequirements__pmj6u","valid":"PasswordRequirements_valid__JLL-v"};